<template>
  <el-config-provider :locale="locale">
    <div>
      <EdgeDock />
      <router-view />
      <Login v-if="['/wechat_login', '/line_callback', '/wechat_bind', '/line_bind'].indexOf(route.path)" />
    </div>
  </el-config-provider>
</template>

<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router';
import Login from '@/components/Login.vue';
import { useStore } from 'vuex';
import EdgeDock from '@/components/EdgeDock/Index.vue';
import commonService from '@/services/common';
import { onMounted, computed } from 'vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import zhTw from 'element-plus/dist/locale/zh-tw.mjs';
import socketManager from '@/utils/socketManager';

const { getSiteConfig } = commonService;
const router = useRouter();
const route = useRoute();
const store = useStore();
const locale = computed(() => (store.state.user.language === 'zh-CN' ? zhCn : zhTw));
const EXCHANGE_RATE_CACHE_KEY = 'exchange_rate_cache';
const EXCHANGE_RATE_TTL = 6 * 60 * 60 * 1000;
const readExchangeRateCache = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(EXCHANGE_RATE_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.rate || !parsed?.ts) return null;
    if (Date.now() - parsed.ts > EXCHANGE_RATE_TTL) return null;
    return parsed.rate;
  } catch (err) {
    return null;
  }
};
const writeExchangeRateCache = (rate) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(EXCHANGE_RATE_CACHE_KEY, JSON.stringify({ rate, ts: Date.now() }));
  } catch (err) {
    // ignore cache write errors
  }
};
const setExchangeRate = (rate) => {
  store.dispatch('user/setExchangeRate', rate);
  writeExchangeRateCache(rate);
};
onMounted(async () => {
  try {
    router.beforeEach((to, from, next) => {
      next();
    });
    await socketManager.connect();
    const commonSubscribe = socketManager.socket.subscribe('common');
    commonSubscribe.on('message', function (data) {
      if (data.type == 'exchange_rate') {
        if (store.state.user.language === 'zh-CN') {
          setExchangeRate(data.cn_rate);
        } else {
          setExchangeRate(data.tw_rate);
        }
      }
    });
  } catch (err) {
    console.log('err', err);
  }
  const cachedRate = readExchangeRateCache();
  if (cachedRate !== null) {
    setExchangeRate(cachedRate);
  }
  const isCategory = route.name === 'Category';
  if (!isCategory || cachedRate === null) {
    getSiteConfig().then((res) => {
      if (res.code == 0) {
        setExchangeRate(res.result.exchange_rate);
      }
    });
  }
});
</script>

<style>
#webpack-dev-server-client-overlay {
  display: none !important;
}
#app {
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.vs-loading .vs-loading__load {
  transform: none !important;
}
.cursor-pointer {
  cursor: pointer;
}
.login-tip {
  color: #b38200;
  font-size: 12px;
  text-align: center;
}
.service-desc-input {
  margin-top: 10px;
  width: 100%;
  textarea {
    resize: vertical;
    border: 1px solid #fae2b4;
    box-shadow: none !important;
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
}
.el-loading-spinner .path {
  stroke: #ffcd01 !important;
}
.note-tip {
  margin-top: 10px;
  color: #ff4757;
}

.text-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制文本显示为两行 */
  -webkit-box-orient: vertical;
  overflow: hidden; /* 隐藏溢出的文本 */
  text-overflow: ellipsis; /* 显示省略号 */
  word-break: break-all;
}
.el-checkbox {
  .el-loading-mask {
    background: transparent;
  }
}
</style>
